import React, { useEffect, useState } from 'react'
import { message } from 'antd'
import Input from 'meinian-package/src/baseComponent/input'
import Textarea from 'meinian-package/src/component/textarea'
import Modal from 'meinian-package/src/component/modal'
import mes from 'meinian-package/src/utils/message'
import request from 'meinian-package/src/utils/request'
import { MnInputNum } from 'meinian-package/src/component/imageDetail/styleSelect'
import TagList from 'meinian-package/src/component/imageDetail/tagSelection'
import './info.less'
import { util } from 'meinian-package/src/utils'
import { UpgradeModal } from './upgradeImage'

export const QuickEdit = (props) => {
  const {
    inspirationId,
    blogId,
    currentImage,
    onDeleteItem,
    visible,
    setVisible,
    setBanStatus,
    onChange,
    boxIndex,
  } = props
  const elements = (currentImage.boxLabelRetList && currentImage.boxLabelRetList[boxIndex]) || {}
  const { style, texture, technology, rootFabric, fabric, accessories, contour, collar, vamp, element, process, sole } = elements
  const finalElements = { texture, technology, fabric, accessories, contour, collar, vamp, element, process, sole, style }
  const hasElements = texture || technology || rootFabric || fabric || accessories || vamp || element || process || sole
  const showSmartTags = style || hasElements
  const [tags, setTags] = useState([])
  const [editVisible, setEditVisible] = useState(false)

  const [params, setParams] = useState(currentImage)

  const fetchTag = async () => {
    const _tags = await request.get(`/zhikuan/img-tag/list-img-tag?entityId=${blogId}`)
    setTags(_tags?.map(m => m.tagName) || [])
  }

  useEffect(() => {
    if (visible) {
      fetchTag()
      setParams({ ...currentImage })
    }
  }, [visible, currentImage])

  const events = {
    onChangeParams(value) {
      setParams(pre => ({ ...pre, ...value }))
    },
    onTagsChange(value) {
      setTags(value)
    },
    onAddTag(tag) {
      tags.add(tag)
      setTags(new Set(tags))
    },
    onDeleteTag(tag) {
      tags.delete(tag)
      setTags(new Set(tags))
    },
    async onSubmit() {
      try {
        const param = {
          inspirationId,
          entityId: blogId,
          styleTitle: params.styleTitle,
          styleDesc: params.styleDesc,
          tagNameList: [...tags.values()],
          price: params?.price && parseFloat(params.price),
          isQuickUpdate: true
        }
        await request.post('/zhikuan/ins/inspiration/add-style-info', param)
        message.success('修改成功！')
        const NParams = { // 不懂为什么是这个结构
          ...param,
          imageEntityExtend: {
            styleTitle: params.styleTitle
          },
        }
        onChange?.(true, NParams)
      } catch (err) {
        console.error(err)
        message.warning(err.errorDesc)
        mes.pub('onMNUploadImage')
      }
      setVisible(false)
      setBanStatus?.(false)
    }
  }

  useEffect(() => {
    if (editVisible) {
      setBanStatus?.(true)
    } else {
      setBanStatus?.(false)
    }
  }, [editVisible])

  return <>
    <span className="mn-style-quick-edit" onClick={() => { setVisible(true); setBanStatus?.(true) }}>{props.children}</span>
    {visible ? <Modal
      centered
      title={<span style={{ color: 'var(--m-text-1)' }}>快速编辑</span>}
      className="style-detail-quick-edit-modal"
      width={556}
      visible={visible}
      maskClosable={false}
      onCancel={() => { setVisible(false); setBanStatus?.(false) }}
      onOk={() => events.onSubmit()}
    >
      <div className="section-item" style={{ fontWeight: 500 }}>
        <span className="label">款式名称</span>
        <Input
          placeholder="输入款式名称，比如2021夏季连衣裙"
          withBorder
          wrapClassName="style-title-input-edit"
          value={params?.styleTitle}
          maxLength={50}
          showCount
          suffix={`${params.styleTitle?.length || 0}/50`}
          onChange={e => events.onChangeParams({ styleTitle: e.target.value })}
          wrapStyle={{ flex: 1, paddingLeft: 9 }}
        />
      </div>
      <div className="section-item">
        <span className="label">款式描述</span>
        <Textarea
          placeholder="输入内容，来让自己或其他成员更好的了解款式的面料，辅料、工艺、风格、颜色及卖点"
          wrapClassName="style-desc-textarea-edit"
          withBorder
          value={params?.styleDesc}
          suffix={<div className="suffix">{`${params.styleDesc?.length || 0}/400`}</div>}
          minHeight={100}
          maxLength={400}
          onInput={e => events.onChangeParams({ styleDesc: e.target.value })}
        />
      </div>

      <div className="section-item">
        <span className="label">添加标签</span>
        <TagList
          type="fetchInterface"
          className="style-lable-tag"
          value={tags}
          smartTags={finalElements}
          showSmartTags={showSmartTags}
          onChange={events.onTagsChange}
          suffix={20}
          style={{ width: '100%', marginBottom: 0 }}
        />
      </div>
      <div className="section-item">
        <span className="label">参考价格</span>
        <MnInputNum
          value={params?.price}
          maxNum={10000000}
          onChange={(value) => {
            if (!/^\d+(.\d{1,2})?$/.test(Number(value))) {
              return
            }
            if (Math.ceil(Number(value)) > 10000000) {
              return message.warning('最多支持输入9999999.99')
            }
            events.onChangeParams({ price: value || 0 })
          }}
        />
      </div>
      <button
        type="button"
        className="edit-more-btn"
        onClick={() => {
          util.track('mn_edit_style', {
            module1: '款式详情页',
            module2: '款式详情',
          })
          setEditVisible(true); setVisible(false); setBanStatus?.(false)
        }}
      >编辑更多信息</button>
    </Modal> : null}
    {editVisible ? <UpgradeModal
      visible={editVisible}
      setVisible={setEditVisible}
      inspirationId={inspirationId}
      onClose={() => { setEditVisible(false) }}
      currentImage={currentImage}
      onChange={(success, itemParams) => { onChange?.(success, itemParams); setEditVisible(false) }}
      blogId={blogId}
      onDeleteItem={onDeleteItem}
      // noAuth={!userAuth.isPermissions(auth, ['FS05', 'FS05_CREATOR', 'FCS06', 'FCS06_CREATOR'])}
    /> : null}
  </>
}
